export const icon = <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.8125 6.90527L13 12.999L25.1875 6.90527V19.9053L13 25.9989L0.8125 19.9052V6.90527Z" fill="#DB5449"/>
<path d="M0.8125 8.12402V11.9224L12.9594 17.874L25.1874 11.9021V8.12402L13 14.096L0.8125 8.12402Z" fill="#C54B42"/>
<path d="M13 25.9989V12.999L1.62501 7.31152H0.8125V19.9053L13 25.9989Z" fill="#D05045"/>
<path d="M0.8125 8.12402V11.9224L12.9594 17.874L13 17.8537V14.0756V14.0959L0.8125 8.12402Z" fill="#BB483E"/>
<path d="M0 6.47968L13 0L26 6.47968V7.33283L13 13.8124L0 7.3531V6.47968Z" fill="#EB6258"/>
<path d="M20.4547 2.0506C20.0281 1.27874 19.1141 0.811523 18.0375 0.811523C15.5797 0.811523 13.8532 3.10685 13 4.56935C12.1469 3.10685 10.4 0.831844 7.96251 0.831844C6.39846 0.831844 5.28125 1.78654 5.28125 3.08653C5.28125 5.40213 7.82032 6.90527 12.9187 6.90527C18.0171 6.90527 20.7187 4.97561 20.7187 3.10685C20.7188 2.74124 20.6375 2.37563 20.4547 2.0506ZM8.49069 4.54909C7.92192 4.16315 7.71882 3.73658 7.71882 3.4522C7.71882 3.1069 8.04384 2.84284 8.51101 2.84284C9.6079 2.84284 10.4813 4.28502 10.9688 5.28036C9.68913 5.17876 8.93753 4.83342 8.49069 4.54909ZM17.5094 4.54909C17.0625 4.83347 16.3109 5.17876 15.0313 5.28031C15.4984 4.28502 16.3719 2.84279 17.4891 2.84279C17.9562 2.84279 18.2812 3.10685 18.2812 3.45214C18.2813 3.73658 18.0781 4.1631 17.5094 4.54909Z" fill="#EFEFEF"/>
<path d="M0 6.49902L13 12.8568L26 6.49902V10.7037L12.9594 17.0615L0 10.7037V6.49902Z" fill="#E2574C"/>
<path d="M17.8749 11.029V10.5618L13 7.92119L8.12497 10.5618V11.029L4.875 9.60711V8.95711L12.8375 4.75244L13 4.83367L13.1625 4.75244L21.1249 8.93679V9.58679L17.8749 11.029Z" fill="#EFEFEF"/>
<path d="M17.875 10.5615V23.5412L21.125 21.9162V8.93652L17.875 10.5615Z" fill="#DCDCDC"/>
<path d="M4.875 21.9365L8.12496 23.5615V10.5819L4.875 8.93652C4.875 8.93647 4.875 21.9365 4.875 21.9365Z" fill="#D1D1D1"/>
</svg>

export const arrowLeft = <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.8974 4.87552L9.35213 0.213281C9.07481 -0.0710936 8.62498 -0.0710936 8.34773 0.213281C8.07033 0.498014 8.07033 0.95916 8.34773 1.24353L11.6806 4.66215H0.815627C0.423461 4.66215 0.105469 4.98818 0.105469 5.39065C0.105469 5.79276 0.423461 6.11915 0.815627 6.11915H11.6806L8.3478 9.53776C8.07041 9.82178 8.07041 10.2833 8.3478 10.5677C8.48646 10.7097 8.66829 10.7807 8.85004 10.7807C9.03179 10.7807 9.21354 10.7097 9.3522 10.5677L13.8974 5.90542C14.1748 5.62141 14.1748 5.15989 13.8974 4.87552Z" fill="#87A9FF"/>
</svg>

export const Login = <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.1562 16.8931V10.082C15.1562 8.85246 14.1531 7.84934 12.9236 7.84934H12.3616V4.70726C12.3616 2.11163 10.2499 0 7.6543 0C5.05867 0 2.95094 2.11553 2.95094 4.70726V5.2498C2.95094 5.62061 3.25149 5.91725 3.61839 5.91725C3.98529 5.91725 4.28974 5.61671 4.28974 5.2498V4.70726C4.28974 2.84934 5.80028 1.3388 7.6582 1.3388C9.51613 1.3388 11.0267 2.84934 11.0267 4.70726V7.84934H2.38888C1.15937 7.84934 0.15625 8.84855 0.15625 10.082V16.8931C0.15625 18.1226 1.15937 19.1257 2.38888 19.1257H12.9275C14.157 19.1218 15.1562 18.1226 15.1562 16.8931ZM1.49895 16.8931V10.082C1.49895 9.59016 1.90098 9.18813 2.39278 9.18813H12.9275C13.4193 9.18813 13.8214 9.59016 13.8214 10.082V16.8931C13.8214 17.3849 13.4193 17.7869 12.9275 17.7869H2.38888C1.89708 17.783 1.49895 17.3849 1.49895 16.8931Z" fill="white"/>
</svg>
export const logo = <svg
width={27}
height={37}
viewBox="0 0 27 37"
fill="none"
xmlns="http://www.w3.org/2000/svg"
>
<path
  d="M20.2107 0.539082C16.7919 -0.368573 13.166 -0.132397 9.89686 1.21087C6.62773 2.55414 3.89871 4.92919 2.13429 7.96659C0.369871 11.004 -0.331025 14.5334 0.140625 18.0059C0.612276 21.4784 2.23003 24.6993 4.74225 27.1675L22.6286 9.46535C23.2974 8.8029 23.7782 7.97788 24.0229 7.07319C24.2675 6.1685 24.2673 5.21601 24.0223 4.31142C23.7773 3.40684 23.296 2.58202 22.627 1.91984C21.9579 1.25767 21.1246 0.781466 20.2107 0.539082Z"
  fill="url(#paint0_linear_0_32)"
/>
<path
  d="M6.78875 36.4596C10.2096 37.3702 13.8386 37.1355 17.1107 35.792C20.3827 34.4485 23.1142 32.0718 24.8796 29.0318C26.6451 25.9918 27.3455 22.4592 26.8717 18.9842C26.398 15.5092 24.7767 12.2868 22.2603 9.81885L4.37394 27.5333C3.70514 28.1956 3.22416 29.0204 2.97933 29.9249C2.7345 30.8294 2.73443 31.7817 2.97913 32.6862C3.22383 33.5908 3.70469 34.4156 4.3734 35.078C5.0421 35.7403 5.87512 36.2168 6.78875 36.4596Z"
  fill="url(#paint1_linear_0_32)"
/>
<path
  style={{ mixBlendMode: "multiply" }}
  d="M22.2603 9.81885L4.37394 27.5333C3.70514 28.1956 3.22416 29.0204 2.97933 29.9249C2.7345 30.8294 2.73443 31.7817 2.97913 32.6862C3.22383 33.5908 3.70469 34.4156 4.3734 35.078C5.0421 35.7403 5.87512 36.2168 6.78875 36.4596C8.70142 36.9645 10.6917 37.1164 12.6599 36.9076C4.81723 29.4388 22.2603 9.81885 22.2603 9.81885Z"
  fill="url(#paint2_linear_0_32)"
/>
<g style={{ mixBlendMode: "multiply" }}>
  <path
    style={{ mixBlendMode: "multiply" }}
    d="M6.46017 36.362C3.92136 28.5802 19.1697 12.9094 21.8604 10.2275L4.37395 27.5339C3.72563 28.1758 3.25344 28.9707 3.00202 29.8436C2.7506 30.7165 2.72826 31.6384 2.93711 32.5222C3.14597 33.406 3.57912 34.2224 4.19559 34.8943C4.81207 35.5662 5.5915 36.0714 6.46017 36.362Z"
    fill="url(#paint3_linear_0_32)"
  />
  <path
    style={{ mixBlendMode: "multiply" }}
    d="M22.2014 9.88984C22.22 9.86941 22.2396 9.84995 22.2603 9.83154L22.2014 9.88984Z"
    fill="url(#paint4_linear_0_32)"
  />
</g>
<path
  style={{ mixBlendMode: "screen" }}
  d="M23.9404 7.36426L4.72113 27.1561L22.6292 9.46618C23.2273 8.87751 23.6766 8.15732 23.9404 7.36426Z"
  fill="url(#paint5_radial_0_32)"
/>
<defs>
  <linearGradient
    id="paint0_linear_0_32"
    x1="16.4102"
    y1="-16.6936"
    x2="10.5876"
    y2="20.6652"
    gradientUnits="userSpaceOnUse"
  >
    <stop stopColor="#0096D9" />
    <stop offset={1} stopColor="#00C198" />
  </linearGradient>
  <linearGradient
    id="paint1_linear_0_32"
    x1="9.13537"
    y1="13.6177"
    x2="18.5045"
    y2="32.4244"
    gradientUnits="userSpaceOnUse"
  >
    <stop stopColor="#002DD9" />
    <stop offset={1} stopColor="#00B2AB" />
  </linearGradient>
  <linearGradient
    id="paint2_linear_0_32"
    x1="23.8071"
    y1="-3.42481"
    x2="6.08252"
    y2="38.1709"
    gradientUnits="userSpaceOnUse"
  >
    <stop stopColor="#3482C0" />
    <stop offset="0.45" stopColor="#96BEDE" />
    <stop offset="0.83" stopColor="#E1EDF6" />
    <stop offset={1} stopColor="white" />
  </linearGradient>
  <linearGradient
    id="paint3_linear_0_32"
    x1="1361.37"
    y1="132.275"
    x2="-132.261"
    y2="2238.51"
    gradientUnits="userSpaceOnUse"
  >
    <stop stopColor="#3482C0" />
    <stop offset="0.45" stopColor="#96BEDE" />
    <stop offset="0.83" stopColor="#E1EDF6" />
    <stop offset={1} stopColor="white" />
  </linearGradient>
  <linearGradient
    id="paint4_linear_0_32"
    x1="25.6732"
    y1="3.26808"
    x2="10.5951"
    y2="32.7125"
    gradientUnits="userSpaceOnUse"
  >
    <stop stopColor="#569FA1" />
    <stop offset="0.36" stopColor="#97C4C5" />
    <stop offset="0.8" stopColor="#E2EEEF" />
    <stop offset={1} stopColor="white" />
  </linearGradient>
  <radialGradient
    id="paint5_radial_0_32"
    cx={0}
    cy={0}
    r={1}
    gradientUnits="userSpaceOnUse"
    gradientTransform="translate(21.5938 32.3818) scale(27.8184 27.5367)"
  >
    <stop stopColor="#FFFF00" />
    <stop offset={1} />
  </radialGradient>
</defs>
</svg>

export const lock = <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.1562 16.8931V10.082C15.1562 8.85246 14.1531 7.84934 12.9236 7.84934H12.3616V4.70726C12.3616 2.11163 10.2499 0 7.6543 0C5.05867 0 2.95094 2.11553 2.95094 4.70726V5.2498C2.95094 5.62061 3.25149 5.91725 3.61839 5.91725C3.98529 5.91725 4.28974 5.61671 4.28974 5.2498V4.70726C4.28974 2.84934 5.80028 1.3388 7.6582 1.3388C9.51613 1.3388 11.0267 2.84934 11.0267 4.70726V7.84934H2.38888C1.15937 7.84934 0.15625 8.84855 0.15625 10.082V16.8931C0.15625 18.1226 1.15937 19.1257 2.38888 19.1257H12.9275C14.157 19.1218 15.1562 18.1226 15.1562 16.8931ZM1.49895 16.8931V10.082C1.49895 9.59016 1.90098 9.18813 2.39278 9.18813H12.9275C13.4193 9.18813 13.8214 9.59016 13.8214 10.082V16.8931C13.8214 17.3849 13.4193 17.7869 12.9275 17.7869H2.38888C1.89708 17.783 1.49895 17.3849 1.49895 16.8931Z" fill="white"/>
<path d="M7.65707 11.9907C7.28626 11.9907 6.98572 12.2913 6.98572 12.6582V14.3873C6.98572 14.7581 7.28626 15.0547 7.65707 15.0547C8.02787 15.0547 8.32452 14.7542 8.32452 14.3873V12.6582C8.32452 12.2913 8.02787 11.9907 7.65707 11.9907Z" fill="white"/>
</svg>

export const arrowRight = <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.3" fill-rule="evenodd" clip-rule="evenodd" d="M20.5731 7.23588L13.8273 0.316535C13.4157 -0.105512 12.7481 -0.105512 12.3367 0.316535C11.925 0.739114 11.925 1.42351 12.3367 1.84556L17.2831 6.91921H1.15809C0.576067 6.91921 0.104126 7.40308 0.104126 8.0004C0.104126 8.59717 0.576067 9.08158 1.15809 9.08158H17.2831L12.3368 14.1552C11.9251 14.5767 11.9251 15.2617 12.3368 15.6837C12.5426 15.8945 12.8124 15.9999 13.0822 15.9999C13.3519 15.9999 13.6216 15.8945 13.8274 15.6837L20.5731 8.76437C20.9848 8.34288 20.9848 7.65793 20.5731 7.23588Z" fill="#0F2137"/>
</svg>

export var titles = ["Ultimate Email  subscription",
  "Bolt Performance",
  "Secure Transaction",
  "Multiple Options",
  "5 Star Rating service",
 " Integrated with Shopify"]
export const paragraphIcons = [
  "A free domain name for life now included with every shared plan on all billing cycles.",
  "If you cancel for any reason within 30 days of ordering, we'll issue you a full refund.",
  "We'll be here when you need us the most. Day or night, even on Christmas Day.",
  "We make it easy to move to CometNine. Simply contact us, and we'll move.",
  "Changing PHP versions is as easy as flipping a switch within cPanel.",
  "Get your info tests delivered at home, collect a sample from your task",
];

export const blogs = [
  {
    title: "Learn from how to host your site",
    date: "October 1, 2023",
    imgSrc: "blog1.jpg",
    paragraph: "JavaScript is a versatile and powerful programming language...",
    name: "FroCode"
  },
  {
    title: "Customize your domain hosting",
    date: "September 15, 2023",
    imgSrc: "blog2.jpg",
    paragraph: "CSS Flexbox is a fantastic layout model that simplifies...",
    name: "Assala"
  },
  
  {
    title: "Learn how to upload on cloud host",
    date: "August 28, 2023",
    imgSrc: "https://www.google.com/search?q=images+dev+ui+ux+1080&tbm=isch&ved=2ahUKEwiE67ahw-6BAxWuJxAIHR-rCR0Q2-cCegQIABAA&oq=images+dev+ui+ux+1080&gs_lcp=CgNpbWcQAzoECCMQJ1C4BVjBCmChDGgAcAB4AIABe4gB4ASSAQMzLjOYAQCgAQGqAQtnd3Mtd2l6LWltZ8ABAQ&sclient=img&ei=HdwmZcToEK7PwPAPn9am6AE&bih=739&biw=1536&rlz=1C1ONGR_enPL1077PL1077#imgrc=V7BeyjPJapRRJM",
    paragraph: "React.js is a popular JavaScript library for building user interfaces...",
    name: "Wassim",
    
  },
  
  {
    title: "Learn how to upload on cloud host",
    date: "August 28, 2023",
    imgSrc: "https://www.google.com/search?q=images+dev+ui+ux+1080&tbm=isch&ved=2ahUKEwiE67ahw-6BAxWuJxAIHR-rCR0Q2-cCegQIABAA&oq=images+dev+ui+ux+1080&gs_lcp=CgNpbWcQAzoECCMQJ1C4BVjBCmChDGgAcAB4AIABe4gB4ASSAQMzLjOYAQCgAQGqAQtnd3Mtd2l6LWltZ8ABAQ&sclient=img&ei=HdwmZcToEK7PwPAPn9am6AE&bih=739&biw=1536&rlz=1C1ONGR_enPL1077PL1077#imgrc=V7BeyjPJapRRJM",
    paragraph: "React.js is a popular JavaScript library for building user interfaces...",
    name: "Djawad"
  },
  
  {
    title: "Learn how to upload on cloud host",
    date: "August 28, 2023",
    imgSrc: "https://www.google.com/search?q=images+dev+ui+ux+1080&tbm=isch&ved=2ahUKEwiE67ahw-6BAxWuJxAIHR-rCR0Q2-cCegQIABAA&oq=images+dev+ui+ux+1080&gs_lcp=CgNpbWcQAzoECCMQJ1C4BVjBCmChDGgAcAB4AIABe4gB4ASSAQMzLjOYAQCgAQGqAQtnd3Mtd2l6LWltZ8ABAQ&sclient=img&ei=HdwmZcToEK7PwPAPn9am6AE&bih=739&biw=1536&rlz=1C1ONGR_enPL1077PL1077#imgrc=V7BeyjPJapRRJM",
    paragraph: "React.js is a popular JavaScript library for building user interfaces...",
    name: "Fethi"
  },
  
  {
    title: "Learn how to upload on cloud host",
    date: "August 28, 2023",
    imgSrc: "https://www.google.com/search?q=images+dev+ui+ux+1080&tbm=isch&ved=2ahUKEwiE67ahw-6BAxWuJxAIHR-rCR0Q2-cCegQIABAA&oq=images+dev+ui+ux+1080&gs_lcp=CgNpbWcQAzoECCMQJ1C4BVjBCmChDGgAcAB4AIABe4gB4ASSAQMzLjOYAQCgAQGqAQtnd3Mtd2l6LWltZ8ABAQ&sclient=img&ei=HdwmZcToEK7PwPAPn9am6AE&bih=739&biw=1536&rlz=1C1ONGR_enPL1077PL1077#imgrc=V7BeyjPJapRRJM",
    paragraph: "React.js is a popular JavaScript library for building user interfaces...",
    name: "Anis"
  },
  
];

export default blogs;

export const faq = [
  {
    question: "Which domain should I purchase?",
    answer: "Choosing the right domain name depends on your business and branding strategy. It's important to select a domain name that is relevant to your business, easy to remember, and reflects your brand. Consider using keywords related to your industry or products."
  },
  {
    question: "Can I upgrade or downgrade my web hosting plan?",
    answer: "Yes, you can typically upgrade or downgrade your web hosting plan with most hosting providers. Contact your hosting provider's customer support or check their website for specific instructions on how to modify your hosting plan."
  },
  {
    question: "How do I upgrade the storage capacity of my hosting plan?",
    answer: "To upgrade the storage capacity of your hosting plan, contact your hosting provider's customer support. They will guide you through the process and may offer you different plans with more storage options."
  },
  {
    question: "What if I need help choosing the right domain?",
    answer: "If you need assistance in choosing the right domain name, you can consult with your hosting provider's customer support or seek advice from a domain registrar. They can provide recommendations based on your business needs and available domain options."
  },
  {
    question: "What is InMotion Hosting’s uptime rate?",
    answer: "InMotion Hosting's uptime rate can vary, and it's recommended to check their website or contact their support for the most current uptime statistics. Uptime rates are important for ensuring your website remains accessible to users."
  },
  {
    question: "We make it easy to move to CometNine. Simply contact us and we'll move your hosting account from any other provider, regardless of the control panel. If at any time your website is down for more than 0.1% result.",
    answer: "CometNine offers easy website migration services, and they are committed to ensuring your website experiences minimal downtime during the migration process. If you face issues with your website's downtime, contact their support for assistance."
  },
  {
    question: "The pricing made me a little hesitant at first, but I have been pleasantly surprised by the level of care given by CometNine.",
    answer: "It's common to have concerns about pricing, but the quality of service and customer care is also crucial. CometNine aims to provide value for your investment, and their high level of customer care may justify the pricing."
  },
  {
    question: "Stop your viewers from getting distracted. Publish videos to your own Channel and rest easy knowing viewers won’t be annoyed by ads or pulled down a rabbit hole of unrelated videos.",
    answer: "Publishing videos on your own channel can help maintain control over the viewing experience. You won't have ads or unrelated content distracting your viewers, providing a better user experience."
  },
  {
    question: "Create a hub for cross-functional work that also works with all your other tools. Centralize and standardize communication with Miro. All premium functionalities are included here with updates.",
    answer: "Miro is a versatile tool for cross-functional collaboration. It integrates with various other tools and offers premium functionalities to enhance communication and teamwork. Check their website for the latest updates and features."
  },
  {
    question: "Learn from the community on Brandwagon. Brian Halligan knows that you need more than a great product to have a great brand. Hear his thoughts & score a peek at our wagon.",
    answer: "Brandwagon is a platform where you can learn from the community and gain insights from experts like Brian Halligan. Building a great brand goes beyond having a great product, and you can find valuable knowledge and perspectives here."
  }
];

// You can use the 'faq' array to display questions and answers on your website or application.
